(function () {
  function initBundleBlock(root) {
    const blocks = root.querySelectorAll('.bundle-giftbox-block');
    if (!blocks.length) return;

    blocks.forEach((block) => {
      if (block.dataset.bundleInit === 'true') return;
      block.dataset.bundleInit = 'true';

      const bulkButtons = block.querySelectorAll('.bundle-bulk-button');
      const mainBtn = block.querySelector('.bundle-gift-main-btn');
      const popup = block.querySelector('.bundle-gift-popup');
      const useDirectBulk = block.dataset.useDirectBulk === 'true';

      if (!bulkButtons.length || !mainBtn) return;

      let selectedBundleVariantIds = [];
      let selectedAddonId = null;

      /* ---------- helpers ---------- */

      function selectBundleFromButton(btn) {
        if (!btn) return false;

        const raw = btn.getAttribute('data-bundle-variants') || '';
        const ids = raw
          .split(';')
          .map((s) => s.trim())
          .filter(Boolean);

        if (!ids.length) return false;

        selectedBundleVariantIds = ids;

        bulkButtons.forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const priceEl = btn.querySelector('.bundle-discounted-price');
        const defaultLabel = mainBtn.dataset.defaultLabel || mainBtn.textContent.trim();
        if (priceEl && defaultLabel.indexOf('{{price}}') !== -1) {
          mainBtn.textContent = defaultLabel.replace('{{price}}', priceEl.textContent.trim());
        }

        return true;
      }

      // init: use .is-selected if present, else first button with variants
      (function initDefaultBundle() {
        let defaultBtn = block.querySelector('.bundle-bulk-button.is-selected');
        if (!defaultBtn) {
          defaultBtn = Array.prototype.find.call(bulkButtons, (b) => {
            const raw = b.getAttribute('data-bundle-variants') || '';
            return raw.split(';').map((s) => s.trim()).filter(Boolean).length;
          });
        }
        selectBundleFromButton(defaultBtn);
      })();

      /* ---------- bundle clicks ---------- */

      //bulkButtons.forEach((btn) => {
        //btn.addEventListener('click', function (e) {
          //e.preventDefault();
          //selectBundleFromButton(this);
       // });
     // });
     /* ---------- bundle clicks (UPDATED) ---------- */

        const popupOnBundleButtons = block.dataset.popupOnBundleButtons === 'true';

        bulkButtons.forEach((btn) => {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    console.log("🔥 CLICK on tier button:", this);

    console.log("selectedBundleVariantIds before select:", selectedBundleVariantIds);

    const ok = selectBundleFromButton(this);
    console.log("selectBundleFromButton ok:", ok);
    console.log("selectedBundleVariantIds after select:", selectedBundleVariantIds);

    console.log("useDirectBulk:", useDirectBulk);
    console.log("popupOnBundleButtons:", popupOnBundleButtons);
    console.log("popup exists:", !!popup);

    if (!ok) {
      console.log("❌ No valid bundle variant IDs");
      return;
    }

    if (useDirectBulk) {
      console.log("➡️ Direct add mode, adding bundle only");
      addBundleToCart(false);
      return;
    }

    if (popupOnBundleButtons) {
      console.log("➡️ Triggering popup from tier button");

      if (popup) {
        console.log("➡️ Popup exists → openPopup()");
        openPopup();
      } else {
        console.log("❗ No popup → add bundle only");
        addBundleToCart(false);
      }
      return;
    }

    console.log("🔸 MODE B: just selecting, popup triggered by main button");
  });
});



      /* ---------- popup + add-to-cart helpers ---------- */

      const overlay = popup?.querySelector('.bundle-gift-popup__overlay');
      const closeBtn = popup?.querySelector('.bundle-gift-popup__close');
      const skipBtn = popup?.querySelector('.bundle-gift-btn-skip');
      const addBtn = popup?.querySelector('.bundle-gift-btn-add');
      const variantTiles = popup ? popup.querySelectorAll('.bundle-gift-variant') : [];

      function openPopup() {
        if (!selectedBundleVariantIds.length) {
          alert('Please select a bundle first.');
          return;
        }

        if (!popup) {
          // no popup configured → just add bundle only
          addBundleToCart(false);
          return;
        }

        popup.classList.add('is-active');
        document.body.classList.add('bundle-giftbox-open');

        if (variantTiles.length && !popup.querySelector('.bundle-gift-variant.is-selected')) {
          const first = variantTiles[0];
          first.classList.add('is-selected');
          selectedAddonId = first.getAttribute('data-variant-id') || null;
        }
      }

      function closePopup() {
        if (!popup) return;
        popup.classList.remove('is-active');
        document.body.classList.remove('bundle-giftbox-open');
      }

      variantTiles.forEach((tile) => {
        tile.addEventListener('click', function () {
          variantTiles.forEach((t) => t.classList.remove('is-selected'));
          this.classList.add('is-selected');
          selectedAddonId = this.getAttribute('data-variant-id') || null;
        });
      });

      async function refreshCartDrawer() {
        try {
          const html = await fetch('/cart').then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (!newDrawer || !currentDrawer) return;
          currentDrawer.classList.remove('is-empty');
          currentDrawer.innerHTML = newDrawer.innerHTML;
        } catch (err) {
          console.warn('bundle_with_giftbox: refreshCartDrawer failed', err);
        }
      }

      async function addBundleToCart(includeAddon) {
        if (!selectedBundleVariantIds.length) return;

        const items = selectedBundleVariantIds.map((id) => ({
          id,
          quantity: 1,
        }));

        if (includeAddon && selectedAddonId) {
          items.push({ id: selectedAddonId, quantity: 1 });
        }

        try {
          mainBtn.disabled = true;

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          }).then((r) => r.json());

          await refreshCartDrawer();

          const drawerEl = document.querySelector('cart-drawer');
          if (drawerEl) {
            drawerEl.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        } catch (err) {
          console.error('bundle_with_giftbox: addBundleToCart failed', err);
        } finally {
          mainBtn.disabled = false;
        }
      }

      /* ---------- main CTA ---------- */

    

      /* ---------- main CTA (UPDATED) ---------- */

            mainBtn.addEventListener('click', function (e) {
              e.preventDefault();

              if (!selectedBundleVariantIds.length) {
                alert('Please select a bundle first.');
                return;
              }

              /* MODE C — direct add */
              if (useDirectBulk) {
                addBundleToCart(false);
                return;
              }

              /* MODE A — popup triggered by bundle buttons → main button disabled */
              if (popupOnBundleButtons) {
                return; // main button does nothing
              }

              /* MODE B — old behavior → open popup here */
              openPopup();
            });


      // Hover image swap for bundle gift variants
document.querySelectorAll('.bundle-gift-variant img[data-hover]').forEach(function(img) {
  const originalSrc = img.getAttribute('src');
  const hoverSrc    = img.getAttribute('data-hover');

  img.addEventListener('mouseenter', function() {
    if (hoverSrc) img.setAttribute('src', hoverSrc);
  });

  img.addEventListener('mouseleave', function() {
    img.setAttribute('src', originalSrc);
  });
});
      /* ---------- popup buttons ---------- */

      if (!useDirectBulk && popup) {
        overlay?.addEventListener('click', function (e) {
          e.preventDefault();
          closePopup();
          addBundleToCart(false); // skip addon
        });

        closeBtn?.addEventListener('click', function (e) {
          e.preventDefault();
          closePopup();
          addBundleToCart(false);
        });

        skipBtn?.addEventListener('click', function (e) {
          e.preventDefault();
          closePopup();
          addBundleToCart(false);
        });

        addBtn?.addEventListener('click', function (e) {
          e.preventDefault();
          closePopup();
          addBundleToCart(true); // bundle + addon
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundleBlock(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initBundleBlock(evt.target);
  });
})();
